var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.112 17.4992L22.7959 13.1577H18.583V10.3358C18.583 9.14867 19.1712 7.98869 21.0519 7.98869H22.9942V4.29169C21.8631 4.11148 20.7202 4.01399 19.5747 4C16.1073 4 13.8435 6.08253 13.8435 9.84737V13.1577H10V17.4992H13.8435V28H18.583V17.4992H22.112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/IconFacebook.10ba5f69e034f55b44d7693b051141dd.svg";
export { ForwardRef as ReactComponent };